<template>
    <div :style="styletop" v-if="isShow">
        <!-- <div style="float: left;margin: 10px 0px 0px 10px;">
            <Icon size="24" @click="toLongin" type="md-arrow-back"/>
        </div> -->
        <div style="height:25%;font-size:20px;line-height: 250px;">
            注册账号
        </div>
        <div>
            <Input v-model="userName" placeholder="用户名" style="width: 70%"/>
            <br><br>
            <Input type="password" v-model="passWord" placeholder="密码/新密码" style="width: 70%"/>
            <br><br>
            <Input type="password" v-model="confirmPassWord" placeholder="确认密码/旧密码" style="width: 70%"/>
            <br><br>
            <Input v-model="fullName" placeholder="姓名" style="width: 70%"/>
            <br><br>
            <Input v-model="tatil" placeholder="电话号码" style="width: 70%"/>
            <br><br>
            <i-button type="primary" :loading="loading" @click="registerUser" style="width: 70%">
                <span v-if="!loading">注册</span>
                <span v-else>注册中</span>
            </i-button>
            <br><br>
            <i-button type="success" long @click="modifyUser" style="width: 70%">修改</i-button>
            <br><br>
            <i-button type="success" long @click="toLongin" style="background-color:red;border-color:red;width: 70%">放弃</i-button>
        </div>
    </div>
</template>
<script>
    import md5 from 'js-md5';
    import axios from 'axios';
    export default {
        name : "userRegister",
        mounted : function(){
            this.isShow = false;
            this.$store.registerModule(['system','userRegister'],{
                state : {
                    $ : this
                }
            });
        },
        data : function(){
            return {
                userName:"",
                passWord:"",
                fullName:"",
                tatil:"",
                confirmPassWord:"",
                loading:false,
                isShow:false,
                styletop : {
                    width : innerWidth +"px",
                    height: innerHeight +"px",
                    color: "#fff",
                    margin:"0px",
                    padding:"0px",
                    overflowX:"hidden",
                    overflowY:"hidden",
                    background : 'url(../../static/appBc.png)',
                    backgroundSize : 'cover'
                }
            }
        },
        methods : {
            show : function(isShow,socketId,data){
                this.isShow = isShow;
            },
            registerUser : function(){
                this.loading = true;
                if(this.userName == ""){
                    this.$Message.info('用户名不能为空');
                    this.loading = false;
                    return;
                }
                if(this.passWord == ""){
                    this.$Message.info('密码不能为空');
                    this.loading = false;
                    return;
                }
                if(this.confirmPassWord != this.passWord){
                    this.$Message.info('两次输入的密码不匹配');
                    this.loading = false;
                    return;
                }
                axios.post(window.debugFWebView+"/register",{
                    userName: this.userName,
                    passWord: md5(this.passWord)
                }).then((result)=>{
                    this.loading = false;
                    this.$Message.info(result.data.err);
                    this.isShow = false;
                    this.$store.state.system.loginApp.$.show(true);
                });
            },
            modifyUser:function(){
                this.loading = true;
                if(this.userName == ""){
                    this.$Message.info('用户名不能为空');
                    this.loading = false;
                    return;
                }
                if(this.passWord == ""){
                    this.$Message.info('新密码不能为空');
                    this.loading = false;
                    return;
                }
                if(this.confirmPassWord == ""){
                    this.$Message.info('请输入当前密码');
                    this.loading = false;
                    return;
                }
                axios.post(window.debugFWebView+"/modify",{
                    userName: this.userName,
                    passWord: md5(this.passWord)
                }).then((result)=>{
                    this.loading = false;
                    this.$Message.info(result.data.err);
                    this.isShow = false;
                    this.$store.state.system.loginApp.$.show(true);
                });
            },
            toLongin:function(){
                this.isShow = false;
                this.$store.state.system.loginApp.$.show(true);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/system/userRegister.vue